import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, filter, map, of, timeout } from 'rxjs';

import { FeatureFlagKeys } from '../app-entities/feature-flag/feature-flag-state.model';
import { featureFlagSelectors } from '../app-entities/feature-flag/feature-flag-state.selectors';
import { Scopes } from '../app-global/entitlements/entitlements.models';
import { selectFeatureEnabled, selectHasScopes } from '../app-global/entitlements/entitlements.selectors';
import { APP_ROUTES } from '../app-global/router/app-routes';

import { GUARD_TIMEOUT_MS } from './guard-timeout';

const homeRoute = `/${APP_ROUTES.App}/${APP_ROUTES.Home}`;

/**
 * Guard for the Maz route
 *
 * Checks both the feature flag and company entitlement for maz
 *
 * Waits for entitlements to have returned before deciding
 *
 * Fails gracefully after a set time so user isn't stranded
 */
export const MazEntitlementGuardFn: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectHasScopes).pipe(
    filter(hasScopes => hasScopes),
    concatLatestFrom(() => [
      store.select(featureFlagSelectors.selectById(FeatureFlagKeys.mobileMaz)),
      store.select(selectFeatureEnabled(Scopes.mazConversationalData)),
    ]),
    map(([, mobileMazEnabled, entitled]) => (mobileMazEnabled && entitled ? true : router.parseUrl(homeRoute))),
    timeout(GUARD_TIMEOUT_MS),
    catchError(() => of(router.parseUrl(homeRoute)))
  );
};
